import React, { useState, useContext } from 'react';
import axios from '../../../../axios/index';

// Context
import { UserContext } from '../../../Context/UserContextProvider';

// components
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
import ImageUploading from "react-images-uploading";
import Dropdown from 'react-bootstrap/Dropdown';

// styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css";
import styles from "./EditCategoryModal.module.css";
import uploadImgStyles from "../../DashboardReuseAbleComponents/AddNewFiles/UploadFileImages.module.css"
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"

//Images
import arrowDown from "../../../../assets/img/DashboardICons/ArrowDown.svg"
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg"
import addIcon from "../../../../assets/img/DashboardICons/CircleAddIconBlue.svg"
import portraitIcon from "../../../../assets/img/DashboardICons/PortraitIcon.svg"

const EditCategoryModal = (props) => {
    const { userToken } = useContext(UserContext);

    const [btnLoader, setBtnLoader] = useState(false)
    const [image, setImage] = useState([]);
    const maxNumber = 1;
    // console.log(props.categories)

    const [selectCategory, setSelectCategory] = useState("انتخاب دسته بندی");

    const [state, setstate] = useState([]);
    // console.log(state)


    // useEffect(() => {
    //     if (props.categories) {
    //         setstate(
    //             props.categories?.map(v => {
    //                 return {
    //                     id: v.id,
    //                     title: v.title,
    //                     slug: v.slug,
    //                 }
    //             })
    //         )
    //     }
    // }, [props.categories])


    // useEffect(() => {
    //     if (props.categories) {
    //         setstate(
    //             props.categories?.map(v => {
    //                 if (selectCategory === v.title) {
    //                     return {
    //                         id: v.id,
    //                         title: v.title,
    //                         slug: v.slug,
    //                     }
    //                 }
    //             })
    //         )
    //     }
    //     console.log(state);
    // }, [props.categories, selectCategory])


    const selectCategoryHandler = (titleCat) => {
        setSelectCategory(titleCat);
        setstate(prevState =>
            props.categories?.filter(v => {
                if (titleCat === v.title) {
                    return {
                        id: v.id,
                        title: v.title,
                        slug: v.slug,
                    }
                }
            })
        )
    }

    const editValueHandler = (e, index) => {
        if (e.target.name === "slug") {
            let value = e.target.value;
            value = value.replace(/[^A-Za-z-0-9]/gi, " ");
            setstate(prevState =>
                prevState.map(val => {
                    if (val.id === index) {
                        return {
                            ...val,
                            [e.target.name]: value
                        }
                    } else {
                        return { ...val }
                    }
                })
            )
        } else {
            setstate(prevState =>
                prevState.map(val => {
                    if (val.id === index) {
                        return {
                            ...val,
                            [e.target.name]: e.target.value
                        }
                    } else {
                        return { ...val }
                    }
                })
            )
        }
    }

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }

            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            ویرایش دسته بندی
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div
                            className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center my-2 mx-2"
                            dir="rtl"
                        >

                            <Dropdown dir='rtl'>
                                <Dropdown.Toggle className="justify-content-between" variant="success" id="dropdown-basic" style={{ minWidth: "185px", width: "auto" }}>
                                    {selectCategory}
                                    <img className='me-3' src={arrowDown} alt="icon" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="h-auto">
                                    {
                                        props.categories &&
                                        props.categories?.map((item) => (
                                            <Dropdown.Item key={item.id} onClick={() => selectCategoryHandler(item.title)}>
                                                {item.title}
                                            </Dropdown.Item>
                                        ))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>

                            {
                                state?.map((item, i) => (
                                    <div key={item.id} className="text-right w-100">
                                        <div className="mt-4">
                                            <Form.Label className={`${styles.title_edit_modal}`}>عنوان دسته بندی</Form.Label>
                                            <Form.Control className={`${styles.input_edit_modal}`} type="text" name="title" value={state.length > 0 && state[i].title} onChange={(e) => editValueHandler(e, item.id)} />
                                        </div>

                                        <div className="mt-4">
                                            <Form.Label className={`${styles.title_edit_modal}`}>عنوان دسته‌بندی(انگلیسی)</Form.Label>
                                            <Form.Control className={`${styles.input_edit_modal}`} type="text" name="slug" value={state.length > 0 && state[i].slug} onChange={(e) => editValueHandler(e, item.id)} />
                                        </div>

                                        <div className='d-flex flex-column justify-content-center align-items-start flex-wrap mt-4'>
                                            <div className="d-flex align-items-center justify-content-center mb-4">
                                                <div className={`ms-2 ${uploadImgStyles.circle_green}`}></div>
                                                <div className={uploadImgStyles.title_sm_gray}>
                                                    آیکون مورد نظر خود را برای دسته‌بندی انتخاب کنید(درصورتی که انتخاب نکنید آیکون قبلی خواهد ماند)
                                                </div>
                                            </div>
                                            <ImageUploading
                                                multiple
                                                value={image}
                                                onChange={onChange}
                                                maxNumber={maxNumber}
                                                dataURLKey="data_url"
                                            >
                                                {({
                                                    imageList,
                                                    onImageUpload,
                                                    onImageRemove,
                                                    dragProps
                                                }) => (
                                                    // write your building UI
                                                    <div className='w-100 d-flex align-items-center flex-wrap'>
                                                        {imageList.map((image, index) => (
                                                            <div key={index} className={`d-flex flex-column align-items-center justify-content-center my-4 ms-4 ${uploadImgStyles.uploaded_img_container}`}>
                                                                <img className={uploadImgStyles.uploaded_img} src={image.data_url} alt="uploaded-img" />
                                                                <div className={uploadImgStyles.remove_img_container}>
                                                                    <img onClick={() => onImageRemove(index)} src={trashIcon} alt="icon" />
                                                                </div>
                                                            </div>
                                                        ))}

                                                        <div className={`d-flex align-items-center justify-content-center mb-2 ${uploadImgStyles.upload_img_container}`}>
                                                            <div className="d-flex flex-column align-items-center justify-content-center position-relative">
                                                                <img src={portraitIcon} alt="icon" />
                                                                <img className={uploadImgStyles.add_icon} src={addIcon} alt="icon" onClick={onImageUpload}
                                                                    {...dragProps} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </ImageUploading>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 d-flex align-items-center justify-content-center ms-4">
                        {btnLoader ? (
                            <div className={Dstyles.btn_loader_container}>
                                <div className={Dstyles.btn_spinner}></div>
                            </div>
                        )
                            : (
                                <button className={ModalStyles.map_btn} onClick={postHandler}>ثبت</button>
                            )
                        }

                    </div>
                </Modal.Footer>
            </Modal>

        </>
    );

    function onChange(imageList) {
        setImage(imageList);
    };

    async function postHandler() {
        setBtnLoader(true)
        var data = new FormData();
        data.append('Id', state[0].id);
        data.append('Title', state[0].title);
        data.append('Icon', image == "" ? state[0].icon : image[0].file);
        data.append('Slug', state[0].slug);
        data.append('SeoData.MetaTitle', state[0].seoData.metaTitle);
        data.append('SeoData.MetaDescription', state[0].seoData.metaDescription);
        data.append('SeoData.MetaKeyWords', state[0].seoData.indexPage);
        data.append('SeoData.IndexPage', false);
        data.append('SeoData.Canonical', state[0].seoData.canonical);
        data.append('SeoData.Schema', state[0].seoData.schema);
        data.append('ParentId', 0);

        const apiData = await axios.put(
            "Category",
            data,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        //console.log(apiData)
        setBtnLoader(false)
        props.onHide()
        window.location.reload(false)
    }
};

export default EditCategoryModal;